import React, { Component } from 'react';
import { Button, Modal, Popconfirm, Badge, message } from 'antd';
import { connect } from 'dva';
import router from 'umi/router';
import SelectUser from 'nbugs-select-user-result-v4.0'
import Container from '../../../../../../components/Container';
import ListPage from '../../../../../../components/ListPage';
import { getAppCode } from '../../../utils/utils';
import { getPathHeader } from '../../../../../../utils/utils';
import OperateDropdown from '../../../../../../components/OperateDropdown';
import styles from './index.less';

const { ListTable } = ListPage;

const statusText = {
  0: '未使用',
  1: '使用中',
};
const statusColor = {
  0: 'rgba(0, 0, 0, 0.25)',
  1: '#1785EC',
};


@connect()

class ContentRecommend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      loading: false,
      record: {},
      page: 1,
      ruleModalVisible: false,
      params: {
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
      },
      totalElements: 0,
      currentListData: {},
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchAllRuleList(params);
  }

  fetchAllRuleList = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'contentRecommend/fetchAllRuleList',
      params
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res.content || [],
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchDeleteRule = record => {
    const { dispatch } = this.props;
    const { params } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'contentRecommend/fetchDeleteRule',
      params: {
        ruleId: record.id,
        appCode: getAppCode(),
      },
    })
      .then(() => {
        this.setState({
          loading: false,
        });
        message.success(`删除成功`)
        this.fetchAllRuleList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  quickUpdate = (data, type) => {
    console.log('quickUpdate data', data, type)
    // "status":0,//规则状态(0未使用/1使用中;默认0)
    // "isRemind":1,//是否提醒(0不提醒/1提醒;默认1)
    const { dispatch } = this.props;
    const { status, isRemind, id } = data;
    const { params } = this.state;
    dispatch({
      type: 'contentRecommend/fetchQuickUpdate',
      params: {
        ruleId: id,
        appCode: getAppCode(),
        status: type === 'status' ? (status === 1 ? 0 : 1) : status,
        isRemind: type === 'isRemind' ? (isRemind === 1 ? 0 : 1) : isRemind,
      },
    }).then(() => {
      if (type === 'isRemind') {
        message.success(`${isRemind === 1 ? '禁用' : '开启'}推送成功`)
      } else {
        message.success(`${status === 1 ? '禁用' : '启用'}成功`)
      }
      this.fetchAllRuleList(params);
    })

  }

  renderAction = record => {
    const { id, status } = record;
    // "status":0,//规则状态(0未使用/1使用中;默认0)
    const data = [
      {
        text: <a onClick={() => {
          this.setState({
            ruleModalVisible: true,
            currentListData: record,
          })
        }}>规则说明</a>,
      },
      {
        text: <a onClick={() => this.intoEdit(id)}>编辑</a>,
      },
      {
        text: <a onClick={() => this.quickUpdate(record, 'status')}>{status === 0 ? '启用' : '禁用'}</a>,
      },
      {
        text: (
          <Popconfirm
            title="确认删除?"
            onConfirm={() => {
              this.fetchDeleteRule(record);
            }}
            okText="确定"
            cancelText="取消"
          >
            <a>删除</a>
          </Popconfirm>
        ),
      },
    ];
    return data;
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchAllRuleList(tempParams);
  };

  intoEdit = id => {
    router.push(`/${getPathHeader()}/webSet/contentRecommend/edit?appCode=${getAppCode()}&id=${id}`);
  }


  render() {
    const {
      loading,
      dataSource = [],
      params,
      ruleModalVisible,
      currentListData = {},
      totalElements,
    } = this.state;
    const { page } = params;
    const { selectId = '', labelVOList = [] } = currentListData;

    const columns = [
      {
        title: '规则名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: text => {
          return <Badge color={statusColor[Number(text)]} text={statusText[Number(text)]} />;
        },
      },
      {
        title: '类型',
        dataIndex: 'typeDesc',
        key: 'typeDesc',
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => {
          const { isRemind, type } = record;
          if (Number(type) !== 1) {
            return <span>
              <a onClick={() => {
                this.setState({
                  ruleModalVisible: true,
                  currentListData: record,
                })
              }}>规则说明</a>
              <a style={{ marginLeft: 8 }} onClick={() => this.quickUpdate(record, 'isRemind')} > {Number(isRemind) === 0 ? '开启推送' : '禁用推送'}  </a>
            </span>

          } else {
            return <OperateDropdown data={this.renderAction(record)} />;
          }
        },
      },
    ];

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    const selectUserProps = {
      multiple: true,
      selectType: "dept",
      strictOrgRel: true,
      selectSignature: selectId,
      isSaveSelectSignature: true,
      requestParams: {
        strictUser: true,
        selectTypeList: ['org_rel'],
      }
    };


    return (
      <Container breStates={!0} version={2}>
        <ListPage {...pageProps}>
          <section className="create-button">
            <Button
              type="primary"
              onClick={() => this.intoEdit('')}
            >
              + 新增规则
            </Button>
          </section>
          <section className="table-area">
            <ListTable {...tableProps} />
          </section>
          <Modal centered title="规则说明" className='content-recommend-rule-info' visible={ruleModalVisible} onOk={() => {
            this.setState({
              ruleModalVisible: false
            })
          }} onCancel={() => {
            this.setState({
              ruleModalVisible: false
            })
          }}>
            <div className='rule-info-type'><span className='line'></span>文章标签</div>
            <div className='label-wrap'>
              {
                labelVOList.map(item => {
                  return <span key={item.labelId}>{item.labelName}</span>
                })
              }
            </div>
            <div className='rule-info-type'><span className='line'></span>推荐对象</div>
            <SelectUser selectUserProps={selectUserProps} />
          </Modal>
        </ListPage>
      </Container>
    );
  }
}
export default ContentRecommend;
